import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TesterAuthProvider } from './auth/TesterAuthProvider';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { LandingPage } from './features/landing/LandingPage';
import { LoginPage } from './features/auth/LoginPage';
import { RedeemPage } from './features/auth/RedeemPage';
import { VerifyPage } from './features/auth/VerifyPage';
import { GatedLayout } from './features/shell/GatedLayout';
import { TesterHome } from './features/dashboard/TesterHome';
import { ReportPage } from './features/report/ReportPage';
import { BoardPage } from './features/board/BoardPage';
import { GuidePage } from './features/guide/GuidePage';

/**
 * Router shell for the UAT Tester Portal.
 *
 * Public routes (no session): `/` public landing (hero / 3-step journey /
 * walkthroughs / capture how-to — epic-uat-portal-001-9); `/guide` the full
 * "How to test" tester guide fed live from the backend (epic-uat-portal-001-13);
 * plus the standalone
 * lightweight auth front doors added in epic-uat-portal-001-8 — `/login`
 * (magic-link request), `/redeem` (invite redemption), `/verify` (magic-link
 * landing). The whole tree is wrapped in `TesterAuthProvider` so every route can
 * read the tester session.
 *
 * Gated routes (ProtectedRoute → redirect to `/login?returnUrl=…` when unauthed)
 * share one shell: a single layout route wraps `GatedLayout` (the persistent
 * authed nav/header — epic-uat-portal-001-14) in `ProtectedRoute`, and the three
 * gated pages render through its `<Outlet/>`: `/app` the signed-in home
 * (`TesterHome`), `/report` the bug-report form (epic-uat-portal-001-10),
 * `/board` the shared status board (epic-uat-portal-001-11). Defining the gate +
 * nav once means every gated page is reachable from every other.
 *
 * The public landing at `/` stays OUTSIDE the gate (plan Task 3).
 */
export default function App() {
  return (
    <BrowserRouter>
      <TesterAuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/guide" element={<GuidePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/redeem" element={<RedeemPage />} />
          <Route path="/verify" element={<VerifyPage />} />

          {/* Gated — one ProtectedRoute + shared GatedLayout nav shell
              (epic-uat-portal-001-8 gate, epic-uat-portal-001-14 shell) */}
          <Route
            element={
              <ProtectedRoute>
                <GatedLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/app" element={<TesterHome />} />
            <Route path="/report" element={<ReportPage />} />
            <Route path="/board" element={<BoardPage />} />
          </Route>
        </Routes>
      </TesterAuthProvider>
    </BrowserRouter>
  );
}
